import React from "react";
import Card from "../Card";
import styles from "./styles.module.sass";

export interface CardData {
  id: string;
  acf: {
    intro?: string;
    image_1: string;
    image_2?: string;
    image_3?: string;
    image_4?: string;
    image_5?: string;
    price?: number;
    in_stock?: boolean;
    purchase_from_hotel?: boolean;
    buy_link?: string;
  };
  content: { rendered: string };
  title: { rendered: string };
}

interface GridProps {
  data: CardData[];
  tile?: React.ComponentType<{
    key: React.Key;
    intro: string;
    imageUrl: string;
    imageUrl2?: string;
    imageUrl3?: string;
    imageUrl4?: string;
    imageUrl5?: string;
    content: string;
    price?: number;
    title: string;
    inStock?: boolean;
    buyFromHotel?: boolean;
    buyLink?: string;
  }>;
}

const Grid: React.FC<GridProps> = ({ data, tile: Tile = Card }) => {
  const renderColumn = (mod: number) =>
    data.map((card, index) => {
      if (index % 3 !== mod) return null;
      return (
        <Tile
          key={card.id}
          intro={card.acf.intro || ""}
          imageUrl={card.acf.image_1}
          imageUrl2={card.acf.image_2}
          imageUrl3={card.acf.image_3}
          imageUrl4={card.acf.image_4}
          imageUrl5={card.acf.image_5}
          content={card.content.rendered}
          price={card.acf.price}
          title={card.title.rendered}
          inStock={card.acf.in_stock}
          buyFromHotel={card.acf.purchase_from_hotel}
          buyLink={card.acf.buy_link}
        />
      );
    });

  return (
    <div className={styles.grid}>
      <div className={styles.column}>{renderColumn(0)}</div>
      <div className={styles.column}>{renderColumn(1)}</div>
      <div className={styles.column}>{renderColumn(2)}</div>
    </div>
  );
};

export default Grid;
